import { VariationService } from "core/service";
import BaseRepository from "core/repository/base.repository";

class VariationRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "variation";
  }

  resourceName() {
    return "variações";
  }

  getServiceProvider() {
    return VariationService;
  }

  async createVariation(params) {
    return this.mService.create(params);
  }

  async getVariation(variationUuid) {
    return this.mService.fetchByUuid(variationUuid);
  }

  async updateVariation(variationUuid, params) {
    return this.mService.update(variationUuid, params);
  }

  async deleteVariation(variationUuid) {
    return await this.mService.delete(variationUuid);
  }
}

export default new VariationRepository();



// WEBPACK FOOTER //
// ./src/core/repository/variation.repository.js